import { render, staticRenderFns } from "./companyModel.vue?vue&type=template&id=ed163fea"
import script from "./companyModel.vue?vue&type=script&lang=js"
export * from "./companyModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed163fea')) {
      api.createRecord('ed163fea', component.options)
    } else {
      api.reload('ed163fea', component.options)
    }
    module.hot.accept("./companyModel.vue?vue&type=template&id=ed163fea", function () {
      api.rerender('ed163fea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/companyManage/companyModel.vue"
export default component.exports